import React from 'react';

const SvgSendFilled = props => (
  <svg
    width="25.333"
    height="21.333"
    fill="none"
    version="1.1"
    viewBox="0 0 25.333 21.333"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(-4,-5.3335)">
      <path
        id="Vector"
        d="m4 26.667v-8.1666l10.067-2.5-10.067-2.5667v-8.1l25.333 10.667z"
        fill="#2466ea"
      />
    </g>
  </svg>
);

export default SvgSendFilled;
